import { IconType } from 'react-icons/lib';
// import { MdSearch as Search } from 'react-icons/md';
import {
  AiFillCheckCircle,
  AiOutlineArrowLeft,
  AiOutlineExclamationCircle as Exclamation,
  AiOutlineDownload as DownloadFile,
  AiFillFile as FileDetails,
  AiOutlinePlus as Plus,
} from 'react-icons/ai';
import { BiPencil as NewPencil } from 'react-icons/bi';
import {
  FaExternalLinkAlt as ExternalLinkAlt,
  FaUser as User,
  FaFile as File,
  FaUserCog as Usercog,
  FaTh as Th,
  FaHome as Home,
  FaSearch as Search,
  FaTasks as Task,
  FaClipboardCheck as Clipboard,
  FaEdit as Edit,
  FaComments as Comments,
  FaFileAlt as Filealt,
  FaEye as Eye,
  FaEyeSlash as CloseEye,
  FaPaperPlane as PaperPlane,
  FaFolder as Folder,
  // FaExclamationCircle as Exclamation,
  FaRegFileAlt as RegFileAlt,
  FaQuestionCircle as QuestionCircle,
  FaFolderOpen as FolderOpen,
  FaShieldAlt as ShieldAlt,
  FaImage as Image,
  FaPaperclip as PaperClip,
  FaFileInvoiceDollar as Dolar,
  FaRegHandshake as handShake,
  FaTrashAlt as Trashed,
} from 'react-icons/fa';

import {
  IoMdMore as MoreVert,
  IoIosArrowDown as RoundedArrowDown,
  IoMdDownload as Download,
  // IoBagRemoveOutline as bag,
} from 'react-icons/io';

// import {} from 'react-icons/io5';

import { VscFile as Paper } from 'react-icons/vsc';

import { RiFileChart2Line as FileChart } from 'react-icons/ri';

import {
  IoClose as Close,
  IoPlayCircle as PlayCircle,
  IoBagRemoveOutline as bag,
} from 'react-icons/io5';

import {
  MdKeyboardArrowLeft as ArrowLeft,
  MdKeyboardArrowRight as ArrowRight,
  MdEdit as Pencil,
  MdDeleteForever as Delete,
  MdDateRange as Calendar,
  MdInfoOutline as Info,
} from 'react-icons/md';

import { BsLaptop as LapTop } from 'react-icons/bs';
import {
  HiOutlineClock as Clock,
  HiOutlineLightBulb as Lamps,
  HiOutlineShieldExclamation as Warning,
} from 'react-icons/hi';
import styled, { css, DefaultTheme } from 'styled-components';
import { MouseEventHandler } from 'react';

type TColor = keyof DefaultTheme['colors'];
type TSize = number;
type TMargin = number | string;

export interface IIcon {
  $iconColor?: TColor;
  /** If it is `number`, it will be in `rem` */
  $iconSize?: TSize;
  /** If it is `number`, it will be in `rem` */
  margin?: TMargin;
  /** If it is `number`, it will be in `rem` */
  marginTop?: TMargin;
  /** If it is `number`, it will be in `rem` */
  marginRight?: TMargin;
  /** If it is `number`, it will be in `rem` */
  marginBottom?: TMargin;
  /** If it is `number`, it will be in `rem` */
  marginLeft?: TMargin;
  clickable?: boolean;
  /** If it is `true`, not add css prop ``color` */
  notColor?: boolean;
  onClick?: MouseEventHandler<SVGElement>;
}

const getMargin = (margin: TMargin) =>
  margin ? (typeof margin === 'number' ? `${margin}rem` : margin) : 'invalid';

const getSize = (size: TSize) => (typeof size === 'number' ? `${size}rem` : size);

const getColor = (color: TColor, theme: DefaultTheme) => theme.colors[color];

// eslint-disable-next-line
const addStyle = (Icon: IconType) => styled(Icon)<IIcon>`
  // eslint-disable-next-line
  // eslint-disable-next-line
  ${({ $iconColor, notColor, theme }) =>
    !notColor &&
    css`
      color: ${$iconColor ? getColor($iconColor, theme) : 'inherit'};
    `};

  font-size: ${({ $iconSize = 1 }) => getSize($iconSize)};

  margin-top: ${({ marginTop = 0 }) => getMargin(marginTop)};
  margin-right: ${({ marginRight = 0 }) => getMargin(marginRight)};
  margin-bottom: ${({ marginBottom = 0 }) => getMargin(marginBottom)};
  margin-left: ${({ marginLeft = 0 }) => getMargin(marginLeft)};
  margin: ${({ margin = 0 }) => getMargin(margin)};

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
      transition: filter 0.2s;

      :hover {
        filter: brightness(80%);
      }

      :active {
        filter: brightness(70%);
      }
    `}
`;

export const icons = {
  home: addStyle(Home),
  th: addStyle(Th),
  usercog: addStyle(Usercog),
  externallinkalt: addStyle(ExternalLinkAlt),
  user: addStyle(User),
  files: addStyle(File),
  info: addStyle(Info),
  search: addStyle(Search),
  task: addStyle(Task),
  clipboard: addStyle(Clipboard),
  edit: addStyle(Edit),
  comments: addStyle(Comments),
  filealt: addStyle(Filealt),
  eye: addStyle(Eye),
  closeEye: addStyle(CloseEye),
  moreVert: addStyle(MoreVert),
  arrowLeft: addStyle(ArrowLeft),
  arrowRight: addStyle(ArrowRight),
  pencil: addStyle(Pencil),
  delete: addStyle(Delete),
  calendar: addStyle(Calendar),
  roundedArrowDown: addStyle(RoundedArrowDown),
  download: addStyle(Download),
  clock: addStyle(Clock),
  close: addStyle(Close),
  paperPlane: addStyle(PaperPlane),
  folder: addStyle(Folder),
  playCircle: addStyle(PlayCircle),
  exclamation: addStyle(Exclamation),
  regfilealt: addStyle(RegFileAlt),
  questionCircle: addStyle(QuestionCircle),
  folderOpen: addStyle(FolderOpen),
  shieldalt: addStyle(ShieldAlt),
  image: addStyle(Image),
  paperClip: addStyle(PaperClip),
  dolar: addStyle(Dolar),
  lamps: addStyle(Lamps),
  handShake: addStyle(handShake),
  fileChart: addStyle(FileChart),
  warning: addStyle(Warning),
  bag: addStyle(bag),
  paper: addStyle(Paper),
  lapTop: addStyle(LapTop),
  arrowLeftAi: addStyle(AiOutlineArrowLeft),
  checkCircle: addStyle(AiFillCheckCircle),
  trashed: addStyle(Trashed),
  fileDonwload: addStyle(DownloadFile),
  fileDetais: addStyle(FileDetails),
  plus: addStyle(Plus),
  newPencil: addStyle(NewPencil),
};
